import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import wayReadAction from './wayRead.action.json' with { type: 'json' }

const wayReadDefinition = defineReadAutoAction(wayReadAction, 'way')

export default wayReadDefinition
